export default (theme) => ({
    actionButtons: {
        width: "50%",
    },
    actionColButtons: {
        borderRadius: 0,
        display: "block",
        height: "50%",
        margin: "0 !important",
        width: "100%",
    },
    actionColFirstChild: {
        borderBottom: `1px solid ${theme.palette.border.lightBorder}`,
    },
    cardContainer: {
        borderRadius: theme.spacing(0.5),
        boxShadow:
            "rgb(0 0 0 / 5%) 0px 6px 24px 0px, rgb(0 0 0 / 8%) 0px 0px 0px 1px",
        display: "flex",
        flexDirection: "row",
        margin: `0 0 ${theme.spacing(1.5)} 0`,
    },
    cardContent: {
        width: "75%",
    },
    cardActions: {
        borderLeft: `1px solid ${theme.palette.border.lightBorder}`,
        display: "block",
        padding: 0,
        width: "25%",
    },
    iconButton: {
        width: "25vw",
    },
    icons: {
        height: "100%",
        width: "100%",
    },
    listContainer: {
        height: "100%",
        overflow: "scroll",
        padding: `${theme.spacing(1.5)}`,
        paddingBottom: theme.spacing(3),
    },
    tabButtons: {
        whiteSpace: "nowrap",
        width: "50%",
    },
    tabsContainer: {
        textAlign: "center",
        width: "100%",
    },
    tabPanel: {
        padding: 0,
    },
    boxWrp: {
        paddingBottom: theme.spacing(13),
    },
    showMoreBtn: {
        width: "100%",
    },
    hideMoreBtn: {
        display: "none",
    },
    nonClickableIcon: {
        color: theme.palette.background.mediumBackground,
    },
});
